import React, { useEffect, useState } from 'react';
import Card from '../../components/card';
import { formatDate } from '../../components/formatters';
import { isObjectModified } from '../../components/property-mapper';
import CompareField from './compare-field';

const DependentReview = ({modified, unmodified}) => {
    const [isModified, setIsModified] = useState();

    useEffect(() => {
        if(!modified || !unmodified)
            setIsModified(true);
        else
            setIsModified(isObjectModified(modified, unmodified));
        
    }, [])

    return ( 
        <Card title={
                <div className='text-sm'>
                    <span className={isModified ? 'text-purple' : 'text-danger'}>{modified.firstName} {modified.lastName}</span>
                </div>        
            }
        >
            <CompareField title="First Name" modifiedValue={modified.firstName} unmodifiedValue={unmodified?.firstName} />
            <CompareField title="Last Name" modifiedValue={modified.lastName} unmodifiedValue={unmodified?.lastName} />
            <div className="print:hidden">
                <CompareField title="Social Security Number" modifiedValue={modified.ssn} unmodifiedValue={unmodified?.ssn} />
            </div>
            <CompareField title="Date of Birth" modifiedValue={formatDate(modified.birthdate)} unmodifiedValue={formatDate(unmodified?.birthdate)} />
            <CompareField title="Relationship" modifiedValue={modified.relationship.name} unmodifiedValue={unmodified?.relationship?.name} />
        </Card>
 );
}
 
export default DependentReview;